import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { MaskLines } from "./Reveal";
import { streamPost } from "../lib/api";

export default function FragmentMachine() {
  const [word, setWord] = useState("");
  const [out, setOut] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const run = async (e) => {
    e.preventDefault();
    if (!word.trim() || busy) return;
    setBusy(true); setErr(""); setOut("");
    try { await streamPost("/ai/fragment", { word: word.trim() }, (t) => setOut((o) => o + t)); }
    catch (e2) { setErr(e2.message); }
    setBusy(false);
  };

  return (
    <section className="px-5 sm:px-8 lg:px-12 py-24 lg:py-32 grid grid-cols-1 lg:grid-cols-12 gap-10" data-testid="fragment-machine">
      <div className="lg:col-span-5">
        <p className="eyebrow mb-4">&sect; Fragment machine</p>
        <h2 className="f-display font-black uppercase text-5xl sm:text-7xl leading-[0.86]"><MaskLines lines={["Give it", <span key="o" className="outline-text">one word.</span>]} /></h2>
        <p className="text-lg text-[#cfcec8] mt-6 max-w-md">It returns a single fragment in the Outlaw voice. Precise lines, human mess.</p>
        <form onSubmit={run} className="mt-10 flex items-end gap-3 border-b border-[var(--bone)] focus-within:border-[var(--signal)] transition-colors max-w-md">
          <input value={word} onChange={(e) => setWord(e.target.value)} maxLength={40} placeholder="grief, signal, home\u2026" className="flex-1 bg-transparent outline-none py-3 f-serif italic text-2xl placeholder:text-[#7d7d77]" data-testid="fragment-input" />
          <button type="submit" disabled={busy} className="pb-4 f-mono text-xs uppercase tracking-[0.2em] flex items-center gap-2 hover:text-[var(--signal)] disabled:opacity-50" data-testid="fragment-submit">{busy ? "Cutting" : "Cut"} <ArrowRight size={14} /></button>
        </form>
      </div>
      <div className="lg:col-span-7 relative min-h-[260px] border border-[var(--line)] flex items-center p-6 sm:p-12 overflow-hidden" data-testid="fragment-output">
        <svg viewBox="0 0 400 260" className="absolute inset-0 w-full h-full" preserveAspectRatio="none" aria-hidden="true">
          <line x1="0" y1="130" x2="400" y2="130" stroke="var(--line)" vectorEffect="non-scaling-stroke" />
          <line x1="200" y1="0" x2="200" y2="260" stroke="var(--line)" vectorEffect="non-scaling-stroke" />
        </svg>
        <p className="relative f-serif italic text-2xl sm:text-4xl leading-snug">
          {err ? <span className="text-[var(--signal)] text-xl not-italic">{err}</span> : out || <span className="text-[#7d7d77]">The lies that blind us are the ties that bind us.</span>}
          {busy && <span className="inline-block w-2 h-7 bg-[var(--signal)] ml-1 align-middle animate-pulse" />}
        </p>
        <span className="absolute bottom-3 right-4 f-mono text-[11px] text-[var(--ash)]">{out ? "AI fragment" : "from Sound & Light"}</span>
      </div>
    </section>
  );
}
